module.exports = __webpack_public_path__ + "img/MoonSword 2b.b62d38a4.png";